import {
    ADVANCED_DISBURSEMENTS_LIST_PAGE_SHIFT,
    CHANGE_ADVANCED_DISBURSEMENTS_LIST_SETTINGS,
    CLEAR_ADVANCE_DISBURSEMENTS_FILTERS, LOGOUT,
    RECEIVE_ALL_ADVANCED_DISBURSEMENTS,
    RECEIVE_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS,
    RECEIVE_ALL_TOBAS,
    TOBAS_LIST_PAGE_SHIFT
} from "../actions";

const defaultState = {
    statusFilter: '',
    viewAmount: '20',
    page: 1,
    totalRecords: 0,
    totalPaginationBoxes: 0,
    suggestions: [],
    textFilter: '',
    amountFrom: '',
    amountTo: '',
    selectedStatuses: [],
    selectedFirms: [],
    selectedCaseTypes: [],
    selectedSubCaseTypes: [],
    wasFilterButtonPressed: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case CLEAR_ADVANCE_DISBURSEMENTS_FILTERS:
            return {
                ...state,
                amountFrom: defaultState.selectedFirms,
                amountTo: defaultState.selectedFirms,
                selectedFirms: defaultState.selectedFirms,
                selectedStatuses: defaultState.selectedStatuses,
                selectedCaseTypes: defaultState.selectedCaseTypes,
                textFilter: defaultState.textFilter,
                wasFilterButtonPressed: false
            };
        case RECEIVE_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS:
            return {
                ...state,
                suggestions: action.payload.body.data
            };
        case RECEIVE_ALL_ADVANCED_DISBURSEMENTS:
            let totalDisplayBoxes = Math.ceil(parseInt(action.payload.body.totalRecords) / parseInt(state.viewAmount));
            let currentPage = parseInt(state.page);
            if(currentPage > totalDisplayBoxes && (totalDisplayBoxes)){
                currentPage = totalDisplayBoxes;
            }
            return {
                ...state,
                totalRecords: action.payload.body.totalRecords,
                page: currentPage,
                totalPaginationBoxes: totalDisplayBoxes
            };
        case ADVANCED_DISBURSEMENTS_LIST_PAGE_SHIFT:
            if (action.payload === 'left' && state.page > 1) {
                return {
                    ...state,
                    page: state.page - 1,
                }
            }
            else if (action.payload === 'right' && state.page < state.totalPaginationBoxes) {
                return {
                    ...state,
                    page: state.page + 1,
                }
            }
            else {
                return state
            }
        case CHANGE_ADVANCED_DISBURSEMENTS_LIST_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case LOGOUT:
            return defaultState;
        default:
            return state;
    }
}